import React, { forwardRef } from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  label,
  error,
  helperText,
  className = '',
  id,
  rows = 3,
  ...props
}, ref) => {
  const textareaId = id || `textarea-${Math.random().toString(36).substr(2, 9)}`;
  return <div className="w-full" data-id="element-6507" data-mp="2jn7ng0acnc8b">
        {label && <label htmlFor={textareaId} className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-6508" data-mp="2jo8xc1fmpsog">
            {label}
          </label>}
        <textarea ref={ref} id={textareaId} rows={rows} className={`
          w-full px-3 py-2 rounded-lg border
          bg-white dark:bg-gray-800
          text-gray-900 dark:text-gray-100
          placeholder-gray-400 dark:placeholder-gray-500
          transition-colors duration-150
          focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent
          disabled:bg-gray-100 disabled:cursor-not-allowed dark:disabled:bg-gray-700
          resize-none
          ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 dark:border-gray-600'}
          ${className}
        `} {...props} data-id="element-6509" data-mp="2slt3noscmf5x" />
        {error && <p className="mt-1 text-sm text-red-500" data-id="element-6510" data-mp="1al6fzq36yh7h">{error}</p>}
        {helperText && !error && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-6511" data-mp="15jh5cbjvs5jx">
            {helperText}
          </p>}
      </div>;
});
Textarea.displayName = 'Textarea';